import { styled } from 'maple-storybook'

import { StyledTypography } from 'variables/styles/typographyStyle.jsx'

const Warning = styled(({ children, ...rest }) => <div {...rest}>{children}</div>)(() => ({
  ...StyledTypography.warningText,
  ...StyledTypography.defaultFontStyle
}))

export default Warning
